import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=4c7a3f87&scoped=true"
import script from "./ModalTip.vue?vue&type=script&lang=js"
export * from "./ModalTip.vue?vue&type=script&lang=js"
import style0 from "./ModalTip.vue?vue&type=style&index=0&id=4c7a3f87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c7a3f87",
  null
  
)

export default component.exports